var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-document-markdown",class:[("link-document-markdown-type-" + _vm.type)],domProps:{"innerHTML":_vm._s(_vm.formatString)}})}
var staticRenderFns = []

export { render, staticRenderFns }